module.exports = __webpack_public_path__ + "static/img/default-portrait.b717ef1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/default-portrait.png
// module id = 0nt9
// module chunks = 2